// extracted by mini-css-extract-plugin
export default {"link":"navigation-link_link__BWbwx","link__label":"navigation-link_link__label__gn4Lg","active":"navigation-link_active__ZI47b"};